import { QwepContext } from '@f_qwep/context/Qwep_context';
import { Property } from '@f_qwep/types';
import { Alert } from '@f_general/alert';
import { Checkbox } from '@mui/material';
import { useContext, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

export function CellStrict({ resultsId }: any) {
    const { t } = useTranslation();
    const { updateProperty, workspaceApplication, batchPricerStrictTasks } = useContext(QwepContext);
    const [checked, setChecked] = useState(false);

    useMemo(() => {
        if (batchPricerStrictTasks) {
            setChecked(batchPricerStrictTasks[resultsId] ?? false);
        }
    }, []);

    const handleChange = async (checked: boolean) => {
        let content;
        if (checked) {
            content = {
                value: {
                    ...batchPricerStrictTasks,
                    [resultsId]: checked,
                },
            };
        } else {
            delete batchPricerStrictTasks[resultsId];
            content = {
                value: batchPricerStrictTasks,
            };
        }

        const result = await updateProperty({
            applicationWorkspaceId: workspaceApplication,
            propertyName: Property.BatchPricerStrictMode,
            value: content,
        });
        if (!result?.isOk) {
            Alert({
                type: 'error',
                text: t('general.error'),
            });
        } else {
            Alert({
                type: 'success',
                text: 'Успешно!',
            });
        }
    };

    return (
        <div>
            <Checkbox onChange={(e) => handleChange(e.target.checked)} checked={checked} /> Без аналогов
        </div>
    );
}
